import { Component } from '@angular/core';
import { CommonStorageKey, ValidationUtil } from './modules/shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  public visible: boolean = false;
  public heightLeftMenu: number = 0;
  public savedLeftMenu: boolean = false;
  public clientheightInit: number = 0;
  public leftheightInit: number = 0;
  hide() {
    this.visible = false;
    this.backStop();
  }

  show(gamenId: string) {
    this.visible = true;
    this.backStop();
    sessionStorage.setItem(CommonStorageKey.GAMENID, gamenId);    
  }

  initLeftMenuHeight() {    
    if (document.getElementById("left_menu_wrap")) {
      this.leftheightInit = document.getElementById("left_menu_wrap").offsetHeight;
      sessionStorage.setItem(CommonStorageKey.LEFTMENUHEIGHT, '' + this.leftheightInit);
    }
  }

  getClientheightInit() {

    return document.body.offsetHeight;
  }

  getHeight() {
    if (this.visible) {
      return '';
    } else {
      return '' + '100%';
    }
    
  }

  getLeftMenuHeight() {
    return ''+this.leftheightInit + 'px';    
  }

  private backStop() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts